import { useEffect, useState } from 'react';
import {
  readConsent,
  subscribeConsent,
  analyticsAllowed,
  type ConsentState,
} from '@/lib/consent';

/**
 * React binding for the cookie-consent store (lib/consent.ts).
 *
 * Re-renders the caller whenever the visitor changes their cookie choice — in
 * this tab (CustomEvent) or another (storage event). Used by the cookie banner
 * and by App to gate analytics on the analytics opt-in.
 */
export function useConsent(): ConsentState | null {
  const [state, setState] = useState<ConsentState | null>(() => readConsent());
  useEffect(() => subscribeConsent(setState), []);
  return state;
}

/** Convenience: reactive «is product analytics allowed right now». */
export function useAnalyticsConsent(): boolean {
  const [ok, setOk] = useState<boolean>(() => analyticsAllowed());
  useEffect(() => subscribeConsent(() => setOk(analyticsAllowed())), []);
  return ok;
}
